import { ContributionFromEnum } from '../api/users/interfaces/ContributionData';

export enum ContributionCategoryEnum {
	COMPANY = 'COMPANY',
	PARTICIPANT = 'PARTICIPANT',
	RESCATE = 'RESCATE'
}

// ⚠️ Semántica validada con datos PROD. Fuente de verdad: comparsa/docs/CONTRIBUCIONES_Y_RESCATES.md
// NO todas las CANCELLMENT_* son rescates:
//  - CANCELLMENT_PARTICIPANT_SAVINGS = RESCATE (disposición). NO es aportación → categoría aparte.
//  - CANCELLMENT_PROMOTER_SAVINGS = CORRECCIÓN de aportación de empresa → netea con COMPANY.
//  - CANCELLMENT_PARTICIPANT_SAVINGS_EXTRAORDINARY = CORRECCIÓN de aportación de empleado → netea con PARTICIPANT.
const COMPANY_TYPES: ContributionFromEnum[] = [
	ContributionFromEnum.COMPANY,
	ContributionFromEnum.CANCELLMENT_PROMOTER_SAVINGS
];

const PARTICIPANT_TYPES: ContributionFromEnum[] = [
	ContributionFromEnum.PARTICIPANT,
	ContributionFromEnum.CANCELLMENT_PARTICIPANT_SAVINGS_EXTRAORDINARY
];

// SOLO el rescate real (disposición). No incluye las correcciones.
const RESCATE_TYPES: ContributionFromEnum[] = [
	ContributionFromEnum.CANCELLMENT_PARTICIPANT_SAVINGS
];

// Cualquier cancelación (rescate + correcciones). Se conserva para usos que necesiten
// detectar "es una cancelación" con independencia de su naturaleza.
const CANCELLATION_TYPES: ContributionFromEnum[] = [
	ContributionFromEnum.CANCELLMENT_PROMOTER_SAVINGS,
	ContributionFromEnum.CANCELLMENT_PARTICIPANT_SAVINGS,
	ContributionFromEnum.CANCELLMENT_PARTICIPANT_SAVINGS_EXTRAORDINARY
];

export function classifyContribution(type: ContributionFromEnum): ContributionCategoryEnum | null {
	if (isRescate(type)) return ContributionCategoryEnum.RESCATE;
	if (COMPANY_TYPES.includes(type)) return ContributionCategoryEnum.COMPANY;
	if (PARTICIPANT_TYPES.includes(type)) return ContributionCategoryEnum.PARTICIPANT;
	return null;
}

/** RESCATE real (disposición): SOLO CANCELLMENT_PARTICIPANT_SAVINGS. NO las correcciones. */
export function isRescate(type: ContributionFromEnum): boolean {
	return RESCATE_TYPES.includes(type);
}

/** Cualquier cancelación (rescate o corrección). */
export function isCancellation(type: ContributionFromEnum): boolean {
	return CANCELLATION_TYPES.includes(type);
}

/**
 * Suma los importes de los RESCATES (no de las correcciones). Devuelve el importe firmado tal cual
 * llega de BBDD (en PROD el rescate aparece positivo). La capa de presentación decide cómo mostrarlo
 * (p.ej. como salida negativa). No es una aportación: no debe sumarse a los totales del participante.
 */
export function sumRescates(
	contributions: { typeContribution: ContributionFromEnum; contributionAmount: number }[]
): number {
	return contributions
		.filter((c) => isRescate(c.typeContribution))
		.reduce((sum, c) => sum + (c.contributionAmount || 0), 0);
}
